import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import { order } from 'styled-system';

export default styled(Box)`
  ${order};
  position: relative;
`;
